<!-- 备品备件出库详情页面 -->
<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model
        :label-col="{ span: 5 }"
        :model="model"
        :rules="validatorRules"
        :wrapper-col="{ span: 12 }"
        ref="form"
        slot="detail"
      >
        <a-row>
          <!-- <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="领用单编码" prop="adoptionCode">
              <a-input placeholder="请输入领用单编码" v-model="model.adoptionCode"></a-input>
            </a-form-model-item>
          </a-col>-->
          <a-col :span="8">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="领用时间" prop="adoptionTime">
              <j-date placeholder="请选择领用时间" style="width: 100%" v-model="model.adoptionTime" />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="领用总金额" prop="totalAmount">
              <a-input-number placeholder="请输入领用总金额" style="width: 100%" v-model="model.totalAmount" />
            </a-form-model-item>
          </a-col>

          <a-col :span="8">
            <!-- <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="领用人名称" prop="adopterName">
              <a-input placeholder="请输入领用人名称" v-model="model.adopterName"></a-input>
            </a-form-model-item>-->
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="领用人" prop="adopterId">
              <a-input v-model="model.adopterId_dictText"></a-input>
            </a-form-model-item>
          </a-col>

          <a-col :span="8">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注" prop="remark">
              <a-input placeholder="请输入备注" v-model="model.remark"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="任务类型" prop="taskTable">
              <a-input v-model="model.taskTable_dictText"></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
    <!-- 备件出库详情页面 list  -->
    <bpBjLeadoutList :triggerId="triggerId" ref="bpBjLeadoutList"></bpBjLeadoutList>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'
  import bpBjLeadoutList from './bpBjLeadoutList'

  export default {
    name: 'DevBpbjLeadoutRecordForm',
    components: {
      bpBjLeadoutList
    },
    props: {
      // 表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      },
      triggerId: {
        type: String,
        default: ''
      },
    },
    data () {
      return {
        model: {
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        confirmLoading: false,
        validatorRules: {
          adoptionCode: [
            { required: true, message: '请输入领用单编码!' }
          ]
        },
        url: {
          add: '/spareparts/devBpbjLeadoutRecord/add',
          edit: '/spareparts/devBpbjLeadoutRecord/edit',
          queryById: '/spareparts/devBpbjLeadoutRecord/queryById'
        }
      }
    },
    computed: {
      formDisabled () {
        return this.disabled
      }
    },
    created () {
      // 备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model))
    },
    methods: {
      selectTz (v, attrName) {
        const { realname } = { ...v[0] }
        this.model[attrName] = realname
      },
      add () {
        this.edit(this.modelDefault)
      },
      edit (record) {
        this.model = Object.assign({}, record)
        this.$refs.bpBjLeadoutList.getData(record?.id)
        this.visible = true
      },
      submitForm () {
        const that = this
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true
            let httpurl = ''
            let method = ''
            if (!this.model.id) {
              httpurl += this.url.add
              method = 'post'
            } else {
              httpurl += this.url.edit
              method = 'put'
            }
            httpAction(httpurl, this.model, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            }).finally(() => {
              that.confirmLoading = false
            })
          }
        })
      }
    }
  }
</script>
